import { http } from '@pendo/http';
import {
    GUIDE_TRANSLATION_COMPLETE,
    GUIDE_TRANSLATION_PARTIAL,
} from '@/settings/localization-settings/guide-localization.service';

export function isTranslated (translationState) {
    return [GUIDE_TRANSLATION_COMPLETE, GUIDE_TRANSLATION_PARTIAL].includes(translationState);
}

export function importGuideLocalizationFile (subscriptionId, guideId, langCode, fileData) {
    const headers = { 'Content-Type': 'application/xml; charset=UTF-8' };

    return http
        .post(`/api/s/${subscriptionId}/guide/${guideId}/localization/import/${langCode}`, fileData, {
            headers,
            credentials: 'same-origin',
        })
        .then((resp) => resp.data);
}

export function fetchLocalizationPublicObject (appId) {
    return http.get(`/api/s/_SID_/localization/${appId}`);
}

export function saveLocalizationPublicObject (appId, obj) {
    obj.id = `${appId}`; // required to send a successful PUT

    return http.put(`/api/s/_SID_/localization/${appId}`, obj);
}

export function getTranslatedGuideSteps (guideId, languageCode) {
    return http
        .get(`/api/s/_SID_/guide/${guideId}/step`, { params: { lang: languageCode } })
        .then((translatedSteps) => translatedSteps.data);
}

export function deleteTranslatedStrings (guideId, langCode) {
    return http.delete(`/api/s/_SID_/guide/${guideId}/localization/${langCode}`);
}

export function deleteLanguage (appId, languageCode) {
    return http.delete(`/api/s/_SID_/localization/${appId}/${languageCode}`);
}
